var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDesktopMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 2,
  viewBox: "0 0 12 2",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11 0c.513 0 .936.383.993.883L12 1a.997.997 0 0 1-.883.993L11 2c-.552 0-1-.444-1-1 0-.513.383-.936.883-.993zM6 0c.513 0 .936.383.993.883L7 1a.997.997 0 0 1-.883.993L6 2c-.552 0-1-.444-1-1 0-.513.383-.936.883-.993zM1 0c.513 0 .936.383.993.883L2 1a.997.997 0 0 1-.883.993L1 2c-.552 0-1-.444-1-1C0 .487.383.064.883.007z"
})));
export default SvgFacebookDesktopMore;